import { GridCellProps } from "@progress/kendo-react-grid";
import ApprobationChip from "../../commons/components/ApprobationChip";

export default function ApprouveCell(props: GridCellProps) {
    return <td colSpan={1} className="k-table-td" role="gridcell" aria-colindex={8} aria-selected="false" data-grid-col-index="7">
        <ApprobationChip approuveWeb={props.dataItem.approuve_web} approuveWebAnglais={props.dataItem.approuve_web_ang} disabled={true} />
    </td>;
}